module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.430c024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_hero_768.png
// module id = vFXZ
// module chunks = 0